<div class="p-6 max-w-7xl mx-auto">
  <div class="mb-8 flex flex-col md:flex-row justify-between items-end md:items-center gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-gray-900 tracking-tight">Gestión de Personal</h1>
      <p class="text-gray-500 italic">Control de accesos y perfiles del sistema RMS.</p>
    </div>

    <div class="flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto">

      <button type="button" (click)="toggleMostrarInactivos()"
              class="flex items-center gap-2 px-3 py-2.5 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-xl transition-all shrink-0 cursor-pointer shadow-sm">
        <div class="relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-300"
             [ngClass]="mostrarInactivos ? 'bg-red-500' : 'bg-gray-300'">
          <span class="inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform duration-300 shadow-sm"
                [ngClass]="mostrarInactivos ? 'translate-x-4.5' : 'translate-x-1'"></span>
        </div>
        <span class="text-[10px] font-bold text-gray-600 uppercase tracking-widest">
          Ver Inactivos
        </span>
      </button>

      <div class="relative flex-1 md:w-80 w-full">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
        </div>
        <input type="text" [(ngModel)]="searchTerm" (input)="filtrarUsuarios()" placeholder="Buscar colaborador..."
               class="block w-full pl-10 pr-3 py-2.5 border border-gray-200 rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-[#1e3a8a] outline-none">
      </div>

      @if (authService.hasPermission('admin.usuarios.crear')) {
        <button (click)="abrirModal()"
                class="bg-[#1e3a8a] text-white px-5 py-2.5 rounded-xl font-bold flex items-center gap-2 hover:bg-blue-900 transition-all shadow-lg active:scale-95 w-full sm:w-auto justify-center">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M12 4v16m8-8H4" stroke-width="2" stroke-linecap="round"/></svg>
          Registrar
        </button>
      }

    </div>
  </div>

  <div class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
    @if (loading) {
      <div class="p-20 flex flex-col items-center justify-center animate-pulse">
        <div class="h-12 w-12 border-4 border-[#1e3a8a] border-t-transparent rounded-full animate-spin"></div>
      </div>
    } @else {
      <table class="w-full text-left">
        <thead class="bg-gray-50 border-b border-gray-100 font-bold text-xs text-gray-400 uppercase tracking-widest">
          <tr>
            <th class="p-4">Colaborador</th>
            <th class="p-4 text-center">Permisos</th>
            <th class="p-4 text-center">Estado</th>
            <th class="p-4 text-center">Acciones</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-50">
          @for (u of usuariosFiltrados; track u.id) {
            <tr class="hover:bg-blue-50/30 transition-colors">
              <td class="p-4">
                <div class="flex items-center gap-3">
                  <div class="h-9 w-9 rounded-full bg-[#1e3a8a] flex items-center justify-center text-white font-bold">
                    {{ u.nombre.substring(0,2).toUpperCase() }}
                  </div>
                  <div class="flex flex-col">
                    <span class="font-bold text-gray-900">{{ u.nombre }}</span>
                    <span class="text-[11px] text-gray-500">{{ u.email }}</span>
                  </div>
                </div>
              </td>

              <td class="p-4 text-center">
                <span class="px-2 py-1 rounded bg-blue-50 text-blue-700 text-[10px] font-bold">
                  {{ u.usuarioPermisos.length || 0 }}
                </span>
              </td>

              <td class="p-4 text-center">
                <button (click)="toggleEstado(u)"
                        [disabled]="!authService.hasPermission('admin.usuarios.editar')"
                        [class]="u.estado === 'ACTIVO' ? 'bg-emerald-500' : 'bg-gray-300'"
                        [class.opacity-50]="!authService.hasPermission('admin.usuarios.editar')"
                        class="w-10 h-5 rounded-full relative transition-all disabled:cursor-not-allowed">
                  <div [class]="u.estado === 'ACTIVO' ? 'translate-x-5' : 'translate-x-0'"
                       class="absolute top-1 left-1 w-3 h-3 bg-white rounded-full transition-transform"></div>
                </button>
              </td>

              <td class="p-4 text-center">
                <div class="flex items-center justify-center gap-2">
                  @if (authService.hasPermission('admin.usuarios.editar')) {
                    <button (click)="editarUsuario(u)" class="text-blue-600 hover:bg-blue-50 p-2 rounded-lg transition-colors" title="Editar">
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" stroke-width="2"></path></svg>
                    </button>
                  } @else {
                    <span class="text-gray-300" title="Sin permisos para editar">
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" stroke-width="2"></path></svg>
                    </span>
                  }
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>

  @if (showModal) {
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div class="bg-white rounded-3xl shadow-2xl w-full max-w-3xl overflow-hidden flex flex-col max-h-[90vh]">

        <div class="p-6 border-b flex justify-between items-center bg-gray-50">
          <h3 class="text-xl font-black text-gray-900">{{ isEditing ? 'Editar Perfil' : 'Nuevo Colaborador' }}</h3>
          <button (click)="cerrarModal()" class="text-gray-400 hover:text-red-500"><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M6 18L18 6M6 6l12 12" stroke-width="2"></path></svg></button>
        </div>

        <div class="p-6 overflow-y-auto space-y-8 custom-scrollbar text-left">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="space-y-1">
              <label class="text-[10px] font-bold text-gray-400 uppercase ml-2">Nombre Completo</label>
              <input type="text" [(ngModel)]="nuevoUsuario.nombre" placeholder="Ej. Juan Pérez" class="w-full border p-3 rounded-xl outline-none focus:ring-2 focus:ring-[#1e3a8a]">
            </div>
            <div class="space-y-1">
              <label class="text-[10px] font-bold text-gray-400 uppercase ml-2">Email Corporativo</label>
              <input type="email" [(ngModel)]="nuevoUsuario.email" placeholder="correo@empresa.com" class="w-full border p-3 rounded-xl outline-none focus:ring-2 focus:ring-[#1e3a8a]">
            </div>
          </div>

          @if (authService.hasPermission('admin.permisos.leer')) {
            <div class="space-y-10">
              @for (area of gruposPermisos; track area.titulo) {
                <div class="animate-fade-in">
                  <div class="flex items-center gap-4 mb-6">
                    <h4 class="text-xs font-black text-[#1e3a8a] uppercase tracking-[0.2em] whitespace-nowrap">{{ area.titulo }}</h4>
                    <div class="h-[1px] w-full bg-gray-200"></div>
                  </div>

                  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    @for (modulo of area.modulos; track modulo.nombre) {
                      <div class="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden flex flex-col">

                        <div class="bg-gray-50 px-4 py-3 border-b border-gray-100 flex justify-between items-center">
                          <label class="flex items-center gap-2 cursor-pointer group">
                            <input type="checkbox"
                                  [checked]="isModuloCompleto(modulo)"
                                  (change)="toggleModuloCompleto(modulo, $event)"
                                  class="w-4 h-4 rounded text-[#1e3a8a] focus:ring-[#1e3a8a] cursor-pointer">
                            <span class="text-[11px] font-bold text-gray-600 uppercase group-hover:text-[#1e3a8a] transition-colors">
                              {{ modulo.nombre }}
                            </span>
                          </label>
                        </div>

                        <div class="p-4 space-y-3">
                          @for (p of modulo.permisos; track p.slug) {
                            <label class="flex items-center gap-3 group cursor-pointer">
                              <input type="checkbox"
                                    [checked]="tienePermiso(p.slug)"
                                    (change)="togglePermiso(p.slug)"
                                    class="w-4 h-4 text-[#1e3a8a] border-gray-300 rounded focus:ring-[#1e3a8a] transition-all">
                              <span class="text-sm text-gray-600 group-hover:text-gray-900 transition-colors font-medium">
                                {{ p.nombre }}
                              </span>
                            </label>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          } @else {
            <div class="p-10 text-center bg-amber-50 rounded-2xl border border-amber-100">
              <p class="text-amber-700 text-sm font-medium">No tienes permisos para gestionar el catálogo de seguridad.</p>
            </div>
          }
        </div>

        <div class="p-6 bg-gray-50 flex gap-3 border-t">
          <button (click)="cerrarModal()" class="flex-1 py-3 font-bold text-gray-500 hover:bg-gray-200 rounded-xl transition-all">Cancelar</button>
          <button (click)="guardarUsuario()" class="flex-1 py-3 bg-[#1e3a8a] text-white font-bold rounded-xl shadow-lg hover:bg-blue-900 transition-all active:scale-95">
            {{ isEditing ? 'Guardar Cambios' : 'Crear Usuario' }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
